import { Box, Center, HStack, Spacer, Text } from "@chakra-ui/react";
import { useLangContext } from "configs/languageContext";

const C = { border: "#E2E8F0", muted: "#94A3B8" };

const COPY: Record<string, string> = {
    en: "MonoSOS · A SalveMonos initiative",
    es: "MonoSOS · Una iniciativa de SalveMonos",
    fr: "MonoSOS · Une initiative de SalveMonos",
};

export const PageFooter = () => {
    const { lang } = useLangContext();
    const year = new Date().getFullYear();
    return (
        <Box borderTopWidth="1px" borderColor={C.border} w="100%" bg="white">
            <HStack maxW="1280px" mx="auto" px={{ base: 4, md: 6 }} py={3}>
                <Text fontSize="xs" color={C.muted}>
                    {COPY[lang] ?? COPY.es} · {year}
                </Text>
                <Spacer />
                <Text
                    as="a"
                    href="https://salvemonos.org/"
                    target="_blank"
                    rel="noreferrer"
                    fontSize="xs"
                    color={C.muted}
                    _hover={{ color: "#059669" }}
                >
                    salvemonos.org
                </Text>
            </HStack>
        </Box>
    );
};
